import styled from 'styled-components';

export const RegisterPage = styled.div`
  min-height: 100vh;
  color: #e0d9cc;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  display: flex;
  flex-direction: column;
  background:
    linear-gradient(
      180deg,
      rgba(10, 8, 20, 0.80) 0%,
      rgba(14, 10, 6, 0.72) 40%,
      rgba(10, 8, 20, 0.82) 100%
    ),
    url('/banner.gif') center top / cover no-repeat fixed;
`;

/* ── GAME BG ── */
export const GameBg = styled.div`
  flex: 1;
  position: relative;
  overflow: hidden;
  background:
    linear-gradient(180deg, rgba(10, 8, 20, 0.72) 0%, rgba(14, 10, 6, 0.65) 50%, rgba(10, 8, 20, 0.80) 100%),
    url('/banner.gif') center top / cover no-repeat;

  /* vignette edges so the form card stands out */
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background:
      radial-gradient(ellipse at 15% 55%, rgba(60, 20, 5, 0.40) 0%, transparent 45%),
      radial-gradient(ellipse at 85% 55%, rgba(40, 15, 5, 0.40) 0%, transparent 45%);
    pointer-events: none;
    z-index: 0;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background:
      linear-gradient(90deg,  rgba(4, 2, 1, 0.45) 0%, transparent 20%),
      linear-gradient(270deg, rgba(4, 2, 1, 0.45) 0%, transparent 20%);
    pointer-events: none;
    z-index: 0;
  }
`;

export const PageBody = styled.div`
  position: relative;
  z-index: 2;
  width: 100%;
  min-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 24px 60px;
  gap: 16px;
`;

/* ── LEFT ICON STRIP ── */
export const IconStrip = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-top: 80px;

  .strip-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: rgba(255,215,0,0.1);
      border-color: rgba(255,215,0,0.25);
      color: #ffd700;
    }
  }
`;

/* ── CENTRE COLUMN ── */
export const CentreCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  max-width: 580px;
`;

/* ── PROMO BANNER ── */
export const PromoBanner = styled.div`
  width: 100%;
  max-width: 580px;
  height: 68px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid rgba(255,200,80,0.2);
  background: linear-gradient(90deg, rgba(26,10,5,0.88) 0%, rgba(46,21,8,0.82) 30%, rgba(31,14,6,0.82) 60%, rgba(14,10,26,0.88) 100%);
  backdrop-filter: blur(14px);
  display: flex;
  align-items: center;
  padding: 0 14px;
  gap: 10px;
  position: relative;

  .new-tag {
    background: #e74c3c;
    color: #fff;
    font-size: 9px;
    font-weight: 800;
    padding: 3px 7px;
    border-radius: 4px;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    flex-shrink: 0;
  }

  .banner-text {
    flex: 1;

    .banner-title {
      font-size: 18px;
      font-weight: 900;
      color: #ffd700;
      text-transform: uppercase;
      letter-spacing: 0.06em;
      text-shadow: 0 0 14px rgba(255,215,0,0.5);
      line-height: 1;
    }

    .banner-sub {
      font-size: 10px;
      color: #aaa;
    }
  }

  .banner-tag {
    background: rgba(255,215,0,0.12);
    border: 1px solid rgba(255,215,0,0.3);
    color: #ffd700;
    font-size: 10px;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 4px;
    text-align: center;
    line-height: 1.3;
    flex-shrink: 0;

    .tag-label { font-size: 8px; color: #aaa; display: block; }
  }

  .banner-flags {
    font-size: 12px;
    letter-spacing: 1px;
    flex-shrink: 0;
  }
`;

/* ── REGISTER CARD ── */
export const RegisterCard = styled.div`
  width: 100%;
  max-width: 50 0px;
  background: rgba(20, 12, 8, 0.82);
  border: 1px solid rgba(200, 120, 50, 0.25);
  border-radius: 16px;
  padding: 36px 40px 32px;
  backdrop-filter: blur(20px);
  box-shadow:
    0 24px 64px rgba(0, 0, 0, 0.70),
    0 0 0 1px rgba(255, 160, 60, 0.08),
    inset 0 1px 0 rgba(255, 200, 100, 0.06);

  .card-top-icon {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    border: 1.5px solid rgba(180,100,40,0.5);
    background: rgba(180,100,40,0.12);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 14px;
    color: rgba(200,130,60,0.9);
    font-size: 20px;
  }

  .card-title {
    font-size: 22px;
    font-weight: 800;
    color: #fff;
    text-align: center;
    margin-bottom: 6px;
    line-height: 1.2;
  }

  .card-subtitle {
    font-size: 12px;
    color: #888;
    text-align: center;
    line-height: 1.6;
    margin-bottom: 20px;
  }
`;

/* ── PROFILE BOX ── */
export const ProfileBox = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  background: rgba(0,0,0,0.3);
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 14px;

  .avatar-circle {
    width: 58px;
    height: 58px;
    border-radius: 50%;
    background: rgba(180,100,40,0.3);
    border: 2px solid rgba(180,100,40,0.4);
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
  }

  .profile-fields {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;

/* ── FIELD ── */
export const FieldGroup = styled.div`
  margin-bottom: 12px;

  .field-label {
    font-size: 10px;
    font-weight: 700;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    margin-bottom: 5px;
    display: block;
  }

  .field-wrap {
    position: relative;

    .field-icon {
      position: absolute;
      left: 11px;
      top: 50%;
      transform: translateY(-50%);
      color: #666;
      font-size: 13px;
      pointer-events: none;
    }

    input, select {
      width: 100%;
      background: rgba(0,0,0,0.35);
      border: 1px solid rgba(255,255,255,0.08);
      border-radius: 7px;
      padding: 9px 11px 9px 32px;
      font-size: 13px;
      color: #ccc;
      outline: none;
      font-family: inherit;
      transition: border-color 0.2s;
      appearance: none;
      -webkit-appearance: none;

      &::placeholder { color: #555; }
      &:focus { border-color: rgba(200,130,60,0.5); }
    }

    .select-arrow {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      color: #555;
      font-size: 12px;
      pointer-events: none;
    }
  }
`;

/* ── CAPTCHA ── */
export const CaptchaBox = styled.div`
  background: rgba(240,240,240,0.07);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 4px;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;

  .captcha-check {
    width: 22px;
    height: 22px;
    border: 2px solid #aaa;
    border-radius: 3px;
    background: rgba(255,255,255,0.05);
    cursor: pointer;
    flex-shrink: 0;
    transition: border-color 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #27ae60;
    font-size: 14px;

    &:hover { border-color: #ccc; }
    &.checked { border-color: #27ae60; background: rgba(39,174,96,0.1); }
  }

  .captcha-label {
    flex: 1;
    font-size: 13px;
    color: #aaa;
  }

  .captcha-logo {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    flex-shrink: 0;

    .logo-icon {
      font-size: 18px;
      color: #c8a040;
    }

    .logo-text {
      font-size: 8px;
      color: #666;
      text-align: center;
      letter-spacing: 0.03em;
    }
  }
`;

/* ── SUBMIT BTN ── */
export const SubmitBtn = styled.button`
  width: 100%;
  padding: 13px;
  background: linear-gradient(90deg, #c0392b 0%, #e74c3c 100%);
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 14px;
  letter-spacing: 0.02em;

  &:hover { opacity: 0.9; transform: translateY(-1px); }
  &:active { transform: scale(0.99); }
  &:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }
`;

/* ── SIGN IN FOOTER ── */
export const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .footer-text {
    font-size: 12px;
    color: #666;
  }

  .signin-link {
    font-size: 12px;
    color: #c8a040;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 4px;
    font-weight: 600;
    transition: color 0.2s;

    &:hover { color: #ffd700; }
  }
`;

/* ── RIGHT SIDEBAR ── */
export const LaunchesWidget = styled.div`
  padding-top: 80px;

  .widget-box {
    background: rgba(16,14,32,0.9);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 10px;
    overflow: hidden;
  }

  .widget-header {
    padding: 9px 12px;
    background: rgba(255,215,0,0.06);
    border-bottom: 1px solid rgba(255,215,0,0.1);
    display: flex;
    align-items: center;
    gap: 7px;
    font-size: 9px;
    font-weight: 800;
    color: #ffd700;
    text-transform: uppercase;
    letter-spacing: 0.1em;

    .dot { width: 7px; height: 7px; border-radius: 50%; background: #27ae60; }
  }

  .launch-item {
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 9px 12px;
    border-bottom: 1px solid rgba(255,255,255,0.04);
    cursor: pointer;
    transition: background 0.15s;

    &:hover { background: rgba(255,255,255,0.03); }
    &:last-of-type { border-bottom: none; }

    .launch-avatar {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: 700;
      color: #fff;
      flex-shrink: 0;
    }

    .launch-info {
      flex: 1;
      min-width: 0;

      .launch-name {
        font-size: 12px;
        color: #ccc;
        font-weight: 600;
        display: flex;
        align-items: center;
        gap: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        .verified { color: #27ae60; font-size: 10px; }
      }

      .launch-meta {
        font-size: 10px;
        color: #666;
      }
    }
  }

  .upcoming-row {
    padding: 7px 12px;
    font-size: 10px;
    color: #555;
    text-transform: uppercase;
    letter-spacing: 0.07em;
    border-top: 1px solid rgba(255,255,255,0.04);
  }
`;

/* ── GENDER TOGGLE ── */
export const GenderToggle = styled.div`
  display: flex;
  gap: 6px;
  margin-bottom: 8px;

  button {
    flex: 1;
    padding: 7px 10px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    font-family: inherit;
    transition: all 0.2s;
    background: transparent;
    border: 1px solid rgba(255,255,255,0.1);
    color: #555;

    &.male-active {
      background: rgba(59,130,246,0.18);
      border-color: rgba(59,130,246,0.5);
      color: #60a5fa;
    }

    &.female-active {
      background: rgba(236,72,153,0.18);
      border-color: rgba(236,72,153,0.5);
      color: #f472b6;
    }

    svg { font-size: 13px; }
  }
`;

export const ErrorText = styled.span`
  font-size: 11px;
  color: #e74c3c;
  margin-top: 4px;
  display: block;
`;

export const ShowHideBtn = styled.button`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  transition: color 0.2s;

  &:hover { color: #aaa; }
`;
